import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import CardBlock from "../../../components/CardBlock/CardBlock";
import IndexHeader from "components/Headers/IndexHeader.js";
import { getWishList } from "../../../redux/actions/user_actions";
import { HOST_URL } from "../../../utils/misc.js";
 import NProgress from 'nprogress';

const Product = (props) => {  
  // Get CategoryName
  let userInfo = JSON.parse(localStorage.getItem("user"))

  useEffect(() => { 
    NProgress.start();
    // Scroll To Top
    window.scrollTo(0, 0)
    
    if(userInfo) {
      props.dispatch(getWishList(userInfo.customerId))
    }
  }, [window.location.pathname]);
  
  if(props.user.wishList) {
    NProgress.done();
    return (
      <>
        <IndexHeader title="Yêu Thích" imageUrl={HOST_URL + props.templates.templates.templateProperties.image_wishlistpage} minHeight="500" />
        <div className="container-fluid p-0">
          <div className="text-center productTitle"><h6>Sản phẩm yêu thích</h6></div> 
          <CardBlock
            list={props.user.wishList.wishList}
            type="wishlist"
            title="All Wishlist Products"
          />
        </div>
      </>
    );
  }
  else {
    return(
      <>
        <div className="container">
          <div className="row justify-content-center">
            <div className="text-center loading">
              <img src={HOST_URL + props.templates.templates.templateProperties.image_loading} style={{width: 150}} />       
            </div>
          </div>
        </div>
      </>
    )
  }
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
    templates: state.templates,
  };
};
export default connect(mapStateToProps)(Product);
